import axiosClient from './axiosClient';

const marketCategoryService = {
    get: async (id) => {
        const response = await axiosClient.get(`/vendor/categories/${id}`);
        return response.data;
    },
    all: async (params) => {
        const response = await axiosClient.get('/vendor/categories', { params });
        return response.data;
    },
    selectCategories: async (params) => {
        const response = await axiosClient.get('/vendor/products/categories', { params });
        return response.data;
    },

    create: async (categoryData) => {
        const response = await axiosClient.post('/vendor/categories', categoryData);
        return response.data;
    },
    update: async (id, categoryData) => {
        const response = await axiosClient.put(`/vendor/categories/${id}`, categoryData);
        return response.data;
    },
    delete: async (id) => {
        const response = await axiosClient.delete(`/vendor/categories/${id}`);
        return response.data;
    }
};

export default marketCategoryService;
